import MarkdownIt from 'markdown-it';

/** Converts Markdown to composer-friendly HTML. */
export function markdownToHtml(text: string) {
  const md = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
  });
  const html = md.render(text);

  // CommonMark assumes paragraph with paragraph spacing, but we use empty divs for blank lines.
  return html
    .replace(/<p>([\s\S]+?)<\/p>/g, '<div>$1</div><div><br></div>')
    .replace(/<div><br><\/div>\s*$/, '');
}
